import React from 'react';
// ui-lib imports
import { DinoButton } from '@uchi/ui-lib-react';
// common components
import Grid from '../../../../common/components/Grid/Grid';
// images
import Valera from './img/valera.png';
// styles
import './Description.css';

interface Props {
  className?: string;
}

class Description extends React.Component<Props, {selectedTabIndex: number}> {
  
  private HTML_ID = 'referal-description';
  
  onButtonClick(ev: React.MouseEvent<HTMLDivElement>): void {
    const id = ev.currentTarget.getAttribute('data-anchor');
    if (id && /^#/.test(id)) {
      const toScroll = document.querySelector(id);
      if (toScroll) {
        toScroll.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  }
  
  render(): JSX.Element {
    const windowWidth = window.innerWidth;
    let leftColClass = Grid.itemClass(4);
    let rightColClass = Grid.itemClass(4);
    
    if (windowWidth > 767 && windowWidth < 1024) {
      leftColClass = Grid.itemClass(4);
      rightColClass = Grid.itemClass(4);
    } else if (windowWidth >= 1280 && windowWidth < 1920) {
      leftColClass = Grid.itemClass(6);
      rightColClass = Grid.itemClass(6);
    } else if (windowWidth >= 1920) {
      leftColClass = Grid.itemClass(8);
      rightColClass = Grid.itemClass(4);
    }
    
    return (
      <div id={this.HTML_ID} className={this.HTML_ID}>
        <div className="container">
          <Grid className={`${this.HTML_ID}-inner`}>
            <div className={ leftColClass }>
              <h3 className="name bold">Что такое «Учи +1»?</h3>
              <div className="summary">
                Внешняя реферальная программа «Учи +1» даёт возможность порекомендовать
                своего друга на одну из открытых вакансий в компании Учи.ру.<br/><br/>
                Учи.ру - это прежде всего профессиональная и сплоченная команда.
                И мы убеждены, что среди ваших друзей есть люди, которые отлично впишутся в нашу команду!
              </div>
              <div className="btn-container">
                <DinoButton data-anchor="#vacancies-list" onClick={this.onButtonClick}>Список вакансий</DinoButton>
              </div>
            </div>
            <div className={ rightColClass }>
              <div className="team-photo">
                <img src={Valera} alt=""/>
                <div className="mission">
                  <span>Вдохновляем</span><br/>
                  <span>на развитие! <span className="heart"></span></span>
                </div>
              </div>
            </div>
          </Grid>
        </div>
      </div>
    );
  }
}

export default Description;
